import React from 'react';
import { Link } from 'react-router-dom';
import { CDV_ACCESS_URL } from '../../data/academiaCdv';
import { trackPage } from '../../utils/analytics';
interface CdvHeaderProps {
  secondaryLabel?: string;
  secondaryTo?: string;
  trackingPrefix?: string;
}
export function CdvHeader({
  secondaryLabel = 'Testimonios',
  secondaryTo = '/academia-testimonios',
  trackingPrefix = 'cdv'
}: CdvHeaderProps) {
  return <header className="w-full border-b border-white/10 bg-black" data-id="element-75" data-mp="z933d4q3jyyi">
      <nav aria-label="Principal" className="max-w-6xl mx-auto flex items-center justify-between gap-4 px-4 sm:px-6 py-2.5" data-id="element-76" data-mp="u98boyyhz5ce">
        <p className="text-[0.65rem] sm:text-xs font-bold uppercase tracking-[0.2em] text-gold-metallic whitespace-nowrap" data-id="element-77" data-mp="18zfkemypd9zw">
          Academia de Bienes Raíces
        </p>
        <div className="flex items-center gap-4 sm:gap-6" data-id="element-78" data-mp="ggs2thix0d3k">
          <Link to={secondaryTo} onClick={() => trackPage(`${trackingPrefix}_nav_secondary_click`)} className="text-xs sm:text-sm font-semibold uppercase tracking-wide text-white/80 whitespace-nowrap transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:underline" data-id="element-79" data-mp="gf7be0rwda9x">
            {secondaryLabel}
          </Link>
          <a href={CDV_ACCESS_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPage(`${trackingPrefix}_nav_acceder_click`)} className="text-xs sm:text-sm font-bold uppercase tracking-wide text-gold-metallic whitespace-nowrap transition-colors duration-150 ease-out hover:text-[#E5C04B] focus:outline-none focus-visible:underline" data-id="element-80" data-mp="v7flvpvnruz4">
            Acceder ahora
          </a>
        </div>
      </nav>
    </header>;
}